const commonTranslation = {
  hello: "Bonjour",
  welcome: "Bienvenue",
  english: "Anglais",
  german: "Allemand",
  italian: "Italien",
  french: "Français",
  currentLanguage: "fr-FR",
  notAvailable: "N/D",
  close: "Fermer",
  preview: "Aperçu",
  invoiceDocument: "Document de facture",
  zoomIn: "Agrandir",
  zoomOut: "Réduire",
  rotateRight: "Tourner vers la droite",
  rotateLeft: "Tourner vers la gauche",
  resetZoom: "Réinitialiser le zoom",
  previousPage: "Page précédente",
  nextPage: "Page suivante",
  showPassword: "Afficher le mot de passe",
  hidePassword: "Masquer le mot de passe",
  qrCode: "Code QR",
  drag: "Faire glisser pour réorganiser",
  clickToRefresh: "Cliquer pour actualiser",
  sampleComponent: "Composant d'exemple",
  sidebar: "Barre latérale",
  invalidCredentials: "Identifiants incorrects",
  requestFailed: "Impossible d'effectuer la requête",
  toast_error: "Erreur",
  toast_warning: "Avertissement",
  toast_success: "Succès",
  toast_info: "Information",
  unknownStatus: "Statut inconnu",
  unknownLanguage: "Langue inconnue",
  unknownField: "Informations complémentaires"
};

const loginComponent = {
  email: "E-Mail",
  emailAddress: "Adresse e-mail",
  username: "Nom d'utilisateur",
  password: "Mot de passe",
  login: "Connexion",
  signUp: "S'inscrire",
  multifactorAuthentication: "Authentification multifacteur",
  OTPCode: "Code OTP",
  verifyAndProceed: "Vérifier & continuer",
  resendOTP: "Renvoyer OTP",
  readMore: "Plus d'informations",
  logout: "Se déconnecter",
  loginOrSignup: "Connexion",
  loginWelcome: "Bienvenue ! Veuillez entrer vos informations.",
  enterEmail: "Entrez votre e-mail",
  enterPassword: "Mot de passe",
  getStarted: "Commencer !",
  profile: "Profil",
  assignment_confirmation: "Confirmation d'attribution",
  revoke_confirmation: "Confirmation de révocation",
  verificationRequired: "Vérification requise",
  verificationDescription: "Entrez le code qui apparaît dans votre application d'authentification",
  no_content: "Pas de contenu",
  loginRemember: "Se souvenir de moi pendant 24 heures",
  ForgotPassword: "Mot de passe oublié",
  NoAccount: "Vous n’avez pas de compte ?",
  loginAppInfo: "Je n'ai pas accès à mon application d'authentification",
  loginSuccess: "Connexion réussie",
  loginError: "Erreur de connexion",
  loginHeroTitle: "Bienvenue sur IDP-AI d'UpQuAI",
  loginHeroSubtitle: "Quand la technologie rencontre l'expertise en assurance"
};

const dashboardComponent = {
  gridView: "Vue grille",
  tableView: "Vue de tableau",
  PDFExtraction: "Tableau de bord FNOL",
  search: "Recherche",
  filter: "Filtre",
  filters: "Filtres",
  sortBy: "Trier par",
  refresh: "Actualiser",
  sort: "Trier",
  sortFields: "Champs à trier",
  edit: "Modifier",
  download: "Télécharger",
  versionHistory: "Historique",
  documentName: "Nom du document",
  asc: "Ascendant",
  desc: "Descendant",
  operator: "Opérateur",
  receiverName: "Nom du destinataire",
  receiver: "Destinataire",
  extractedAt: "Extrait le",
  claimAge: "Âge",
  claimAgeLegendTitle: "Âge du dossier vs moyenne",
  claimAgeLegendBody:
    "La couleur indique le temps depuis l'extraction, par rapport à la moyenne des dossiers visibles. Vert = plus récent, rouge = plus ancien.",
  claimAgeAvgBaseline: "Moyenne de la vue : {{age}}",
  claimAgeNewerThanAvg: "{{ratio}}× plus récent que la moyenne",
  claimAgeOlderThanAvg: "{{ratio}}× plus ancien que la moyenne",
  claimAgeAboutAvg: "Proche de la moyenne",
  claimAgeAverageMark: "Moyenne",
  claimAgeTier_fresh: "Récent",
  claimAgeTier_typical: "Typique",
  claimAgeTier_aging: "Vieillissant",
  claimAgeTier_stale: "En retard",
  lastModified: "Dernière modification",
  noOfPages: "Nombre de pages",
  status: "Statut",
  action: "Action",
  details: "Détails",
  generalInformation: "Informations générales",
  medicine_info: "Informations sur les médicaments",
  invoice: "Facture",
  invoiceDate: "Date de la facture",
  invoiceReference: "Référence de facture",
  vetName: "Nom du vétérinaire",
  vetStreet: "Rue du vétérinaire",
  city: "Ville",
  postalCode: "Code Postal",
  language: "Langue",
  policyholderName: "Nom du preneur d'assurance",
  policyholderAddress: "Adresse du preneur d'assurance",
  treatment: "Traitement",
  treatmentDate: "Date du traitement",
  diagnosis: "Diagnostic",
  itemName: "Nom de l'article",
  quantity: "Quantité",
  prize: "Prix",
  VAT: "TVA",
  addTreatment: "Ajouter un traitement",
  addItem: "Ajouter un article",
  total: "Total",
  subTotal: "Sous-total",
  calculatedSum: "Total après rabais",
  notes: "Notes",
  page: "Page",
  pages: "Pages",
  min: " min",
  mins: " mins",
  hour: " heure",
  hours: " heures",
  day: " jour",
  days: " jours",
  month: " mois",
  months: " mois",
  ago: "il y a",
  timeAgoPhrase: "il y a {{count}} {{unit}}",
  modifiedBy: "Modifié par",
  modifiedAt: "Modifié le",
  clickASC: "Cliquer pour trier par ordre croissant",
  clickDESC: "Cliquer pour trier par ordre décroissant",
  petName: "Nom de l'animal",
  items: "Articles",
  treatmentName: "Nom du traitement",
  InvoiceTotalSumPriceWithoutVAT: "Montant total de la facture hors TVA",
  InvoiceTotalSumPriceWithVAT: "Montant total de la facture avec TVA",
  CalculatedTotalSum: "Total calculé",
  TotalDiscountAmount: "Montant total du rabais",
  CalculatedTotalSumAfterDiscount: "Total calculé après rabais",
  recent: "Le plus récent",
  viewHistory: "Voir l'historique",
  remember: "Ne demandez plus aujourd'hui",
  rememberSentance: "Aujourd'hui, nous ne vous demanderons plus de code de confirmation sur votre appareil de confiance lorsque vous vous connecterez.",
  Complete_login: "Terminer la connexion",
  date: "Date",
  time: "Heure",
  note: "Note",
  comment: "Remarque",
  revoke: "Révoquer",
  deleteTreatment: "Supprimer le traitement",
  deleteItem: "Supprimer l'article",
  lastUpdate: "Dernière mise à jour",
  board: "Grille",
  table: "Tableau",
  modified: "Modifié par",
  showing: "Afficher",
  totalSum: "Montant total",
  of: "de",
  none: "Aucun",
  customVAT: "TVA personnalisée",
  quality_level: "Niveau de qualité",
  good: "Bon",
  verify: "À vérifier",
  not_extracted: "Non extrait",
  apply: "Appliquer",
  kpiTotal: "Total",
  kpiNotStarted: "Non commencé",
  kpiInProgress: "En cours",
  kpiCompleted: "Terminé",
  kpiNeedsVerification: "À vérifier",
  kpiFailed: "Échoué",
  archive: "Archiver",
  reprocess: "Retraiter",
  archiveConfirmTitle: "Archiver le document",
  archiveConfirmContent: "Archiver ce document ? Il disparaîtra de la file d'attente mais restera dans l'historique.",
  reprocessConfirmTitle: "Retraiter le document",
  reprocessConfirmContent: "Renvoyer ce document dans l'extraction ? Les données actuelles seront remplacées.",
  failureReason: "Raison de l'échec",
  receivedFrom: "Reçu de",
  receivedAt: "Reçu le",
  documentPreview: "Aperçu du document",
  failure_invalid_file_format: "Format de fichier invalide — le fichier n'a pas pu être lu.",
  failure_invalid_pet_invoice: "Facture vétérinaire invalide — aucune donnée de facture détectée.",
  failure_extraction_issue: "Erreur d'extraction — le traitement a échoué de manière inattendue.",
  documentArchived: "Document archivé",
  documentReprocessing: "Document envoyé pour retraitement",
  archiveError: "Impossible d'archiver le document",
  reprocessError: "Impossible de retraiter le document",
  countsError: "Impossible de charger les compteurs",
  viewDetails: "Voir les détails",
  dateFrom: "De",
  dateTo: "À",
  dateRange: "Plage de dates",
  searchPlaceholderExtended: "Rechercher fichier, assuré, vétérinaire, n° de facture",
  noteBy: "par",
  addNote: "Ajouter une note",
  writeNote: "Écrire une note...",
  notesLog: "Notes",
  duplicateWarning: "Doublon possible : un autre document a la même référence de facture et le même assuré.",
  checkingDuplicate: "Vérification des doublons...",
  fieldsNeedAttention: "champs nécessitent une attention",
  allFieldsComplete: "Tous les champs sont complets",
  vatBreakdown: "Ventilation de la TVA",
  vatRate: "Taux de TVA",
  netAmount: "Net",
  vatAmount: "TVA",
  grossAmount: "Brut",
  totalsMatch: "La somme calculée correspond au total de la facture",
  totalsDelta: "Écart par rapport au total de la facture",
  undoMyEdits: "Annuler mes modifications",
  restoreOriginal: "Restaurer l'extraction originale",
  undoMyEditsContent: "Ignorer toutes vos modifications non enregistrées sur ce document ?",
  restoreOriginalContent: "Restaurer l'extraction originale du serveur ? Toutes vos modifications seront perdues.",
  moveToTreatment: "Déplacer vers le traitement",
  duplicateItem: "Dupliquer l'élément",
  moveUp: "Monter",
  moveDown: "Descendre",
  quantityTimesPrice: "Qté × Prix",
  fullscreen: "Plein écran",
  exitFullscreen: "Quitter le plein écran",
  thumbnails: "Miniatures",
  pageOf: "sur",
  invalidPostalCode: "Saisir un code postal valide (4 chiffres)",
  overrideAuto: "Remplacer la valeur calculée automatiquement par une saisie manuelle",
  discountAppliedAfterSubtotal: "Appliqué après le sous-total",
  verificationCompare: "Vérification : somme existante {{legacy}} vs somme basée sur la quantité {{quantityAware}}",
  jumpToNextAttention: "Aller au champ suivant nécessitant une vérification (Alt+N)",
  moreActions: "Plus d'actions"
};

const commonEvents = {
  add: "Ajouter",
  update: "Mettre à jour",
  save: "Sauvegarder",
  cancel: "Annuler",
  reset: "Réinitialiser",
  download: "Télécharger",
  clear: "Effacer",
  delete: "Supprimer",
  assign: "Attribuer",
  back: "Retour",
  resetInitial: "Rétablir l’état initial",
  enter_notes: "Saisissez vos notes ici...",
  Updated: "Mis à jour",
  Exported: "Exporté",
  Revoked: "Révoqué",
  Assigned: "Attribué",
  medicineDescription: "Description du médicament",
  purpose: "Objectif",
  usedFor: "Utilisé pour",
  petTypes: "Types d'animaux",
  activeIngredients: "Ingrédients actifs",
  category: "Catégorie",
  aiCategory: "Catégorie IA",
  exclusionSubcode: "Sous-code d'exclusion",
  reasoning: "Justification de la catégorie",
  detection_keywords: "Mots-clés détectés",
  translateReasonings: "Traduire les justifications",
  translateReasoningsSuccess: "Justifications traduites",
  translateReasoningsEmpty: "Aucune justification à traduire",
  translateReasoningsTo: "Traduire en {{language}}",
  unclassified: "Non classé",
  reasonForChange: "Raison du changement",
  reasonForChangePlaceholder: "Sélectionnez une raison",
  changeContext: "Contexte supplémentaire",
  changeContextPlaceholder: "Ajoutez plus de détails sur la mise à jour de la classification",
  showMore: "Afficher plus",
  showLess: "Afficher moins",
  typeOfDamage: "Type de dommage",
  causeOfDamage: "Cause du dommage",
  loading: "Chargement...",
  confidenceHigh: "Confiance élevée",
  confidenceMedium: "Confiance moyenne",
  confidenceLow: "Confiance faible",
  feedbackReasonDiagnosis: "Diagnostic",
  feedbackReasonTreatmentContext: "Contexte du traitement",
  feedbackReasonItemTextOrOcr: "Texte de la ligne ou OCR",
  feedbackReasonExclusionRule: "Règle d'exclusion",
  feedbackReasonInvoiceContext: "Contexte de la facture",
  feedbackReasonDuplicateOrWrongLine: "Ligne en double ou incorrecte",
  feedbackReasonExpertJudgment: "Jugement expert",
  feedbackReasonOther: "Autre",
  required: "obligatoire",
  feedbackOriginal: "Classification IA d'origine",
  feedbackCorrected: "Classification corrigée",
  feedbackStatusDraft: "Correction de classification non enregistrée",
  feedbackStatusPending: "Enregistrement du retour de classification…",
  feedbackStatusSaved: "Retour de classification enregistré",
  feedbackStatusError: "Échec du retour de classification",
  feedbackValidationTitle: "Le retour de classification doit être corrigé",
  feedbackValidationDescription: "Corrigez les champs de classification signalés avant d'enregistrer.",
  feedbackReasonRequired: "Sélectionnez un motif pour cette correction.",
  feedbackContextRequired: "Ajoutez un contexte lorsque le motif est Autre.",
  feedbackContextTooLong: "Le contexte ne peut pas dépasser {{max}} caractères.",
  feedbackExclusionSubcodeRequired: "Sélectionnez un sous-code d'exclusion valide.",
  feedbackNonExclusionSubcode: "Les sous-codes d'exclusion ne sont valides que pour la catégorie E.",
  invalidCategory: "Sélectionnez une catégorie valide.",
  feedbackSaveFailed: "Le retour de classification n'a pas été enregistré",
  feedbackConflict: "Cette correction a déjà été envoyée ou entre en conflit avec une correction plus récente.",
  feedbackStale: "La prédiction IA a changé. Rechargez le document avant de la corriger.",
  feedbackNetworkError: "La correction n'a pas pu être enregistrée. Votre brouillon est conservé.",
  feedbackUnavailableLegacy: "Cette catégorie IA ne peut pas être corrigée, car elle n'a pas été enregistrée pour l'apprentissage. Rechargez le document, ou retraitez-le si elle reste verrouillée.",
  feedbackUnavailableRetrying: "La catégorie IA est encore en cours d'enregistrement. Rechargez le document dans quelques minutes pour la corriger.",
  feedbackUnavailableNotStored: "Cette catégorie IA ne peut pas être corrigée, car elle n'a pas été enregistrée dans le journal d'apprentissage. Retravaillez le document.",
  feedbackUnavailableDisabled: "Les corrections de catégorie ne sont pas activées dans cet environnement. La catégorie reste visible, mais ne peut pas être enregistrée.",
  feedbackIdentityRequired: "Cette correction ne peut pas être enregistrée, car l'identifiant de la ligne ou de la prédiction IA est absent. Rechargez ou retraitez le document.",
  feedbackDuplicateItemId: "Ce document contient plusieurs fois le même identifiant de ligne. L'enregistrement est bloqué ; rechargez ou retraitez le document.",
  cat_T: "Traitement médical",
  cat_D: "Décès / Invalidité",
  cat_QS: "Dépistage préventif",
  cat_QP: "Prophylaxie",
  cat_C: "Thérapie complémentaire",
  cat_V: "Vaccination",
  cat_Dx: "Diagnostics avancés",
  cat_G: "Aliments diététiques",
  cat_H: "Séances de thérapie",
  cat_J: "Thérapie comportementale",
  cat_W: "Hospitalisation",
  cat_X: "Bonus retenu",
  cat_S: "Services de sauvetage",
  cat_A: "Paiement direct",
  cat_R: "Rapports vétérinaires",
  cat_E: "Exclusion",
  exc_g: "Frais de transport",
  exc_x: "Frais administratifs",
  exc_z: "TVA",
  exc_p: "Examens de passeport",
  exc_q: "Frais de puce électronique",
  exc_i: "Crémation / Incinération",
  exc_b: "Ferrure de cheval",
  exc_s: "Stérilisation élective",
  exc_c: "Frais de pension",
  exc_m: "Soins non médicaux",
  exc_d: "Exclusion soins dentaires",
  exc_r: "Frais de rapport vétérinaire",
  operatorFallback: "Opérateur Calingo"
};

const documentStatus = {
  not_yet_started: "Pas commencé",
  in_progress: "En cours de traitement",
  completed: "Terminé"
};

const confirmationMessage = {
  deleteConfirmationTitle: "Confirmer la suppression",
  deleteActionTreatmentContent: 
    "Êtes-vous sûr de vouloir supprimer ce traitement ? Cette action ne peut pas être annulée",
  deleteActionItemContent: 
    "Êtes-vous sûr de vouloir supprimer cet article ? Cette action ne peut pas être annulée",
  resetConfirmationTitle: "Confirmer la réinitialisation",
  resetToInitialConfirmationTitle: "Réinitialisation à l'état initial",
  resetActionContent: 
    "Êtes-vous sûr de vouloir effectuer une réinitialisation ? Cette action ne peut pas être annulée",
  resetInitialActionContent: 
    "Êtes-vous sûr de vouloir revenir à l'état initial ? Cette action ne peut pas être annulée",
  assignmentConfirmation: 
    "Êtes-vous sûr de vouloir vous attribuer ce document ?",
  revokeConfirmation: "Êtes-vous sûr(e) de vouloir annuler l'attribution de ce document à vous-même ?",
  reAssignConfirmation: 
    "Êtes-vous sûr de vouloir vous réattribuer ce document ?",
  assignedTo: "Ce document est attribué à"
};

const errorNotification = {
  invalidEmail: "Veuillez saisir une adresse e-mail valide !",
  emailEmpty: "Veuillez saisir votre adresse e-mail !",
  passwordEmpty: "Veuillez saisir votre mot de passe !",
  notAllowedToEdit: "Ce document ne peut pas être modifié",
  noteNotSaved: "Les notes ne sont pas sauvegardées",
  tokenExpired: "Votre session a expiré, veuillez vous reconnecter",
  accessDenied: "Accès refusé",
  notAssigned: "Veuillez vous attribuer le document pour y accéder",
  documentListError: "Impossible de charger la liste des documents",
  genericError: "Une erreur s'est produite"
};

const successNotification = {
  DocumentResetToInitial: "Le document a été rétabli à son état initial",
  UpdateSuccess: "Mise à jour réussie",
  noteSaved: "Les notes ont été sauvegardées avec succès",
  successDocumentProgressStatus: "Attribution réussie",
  revokeDocument: "Attribution révoquée"
};

const batch1Ux = {
  saveAndNext: "Enregistrer & suivant",
  complete: "Terminer",
  completeAndDownload: "Terminer & télécharger",
  completeConfirmTitle: "Terminer le document",
  completeConfirmContent: "Le document sera marqué comme terminé. Continuer ?",
  startProcessing: "Commencer le traitement",
  takeOver: "Reprendre",
  readOnlyAssignedTo: "Lecture seule — ce document est attribué à {{name}}",
  readOnlyNotAssigned: "Ce document n'est pas encore attribué — attribuez-le-vous pour commencer",
  savedAt: "Enregistré à {{time}}",
  unsavedChanges: "Modifications non enregistrées",
  unsavedChangesTitle: "Modifications non enregistrées",
  unsavedChangesContent: "Vous avez des corrections non enregistrées. Quitter sans enregistrer ?",
  restore: "Restaurer",
  discard: "Ignorer",
  restoreDraftTitle: "Restaurer le brouillon non enregistré ?",
  restoreDraftContent: "Un brouillon local de vos corrections non enregistrées a été trouvé pour ce document.",
  leave: "Quitter",
  stay: "Rester",
  queueEmpty: "La file est vide — plus de factures à traiter",
  markedCompleted: "Document marqué comme terminé",
  moreActions: "Plus",
  lastUpdated: "Dernière mise à jour {{time}}",
  mine: "à moi",
  failed: "Échoué",
  completedToday: "Terminés aujourd'hui",
  clearAllFilters: "Effacer tous les filtres",
  selectedCount: "{{count}} sélectionné(s)",
  assignToMe: "Me l'attribuer",
  markCompleted: "Marquer terminé",
  exportSelected: "Exporter la sélection",
  bulkAssignDone: "{{count}} attribué(s), {{skipped}} ignoré(s)",
  bulkCompleteDone: "{{completed}} terminé(s), {{skipped}} ignoré(s)",
  bulkExportDone: "{{count}} documents téléchargés",
  notAllowedToEditReason: "Le document n'a pas pu être extrait (fichier invalide ou contenu illisible), il n'y a donc rien à corriger.",
  totalsMatch: "Total calculé CHF {{calculated}} correspond au total de la facture CHF {{total}}",
  totalsDelta: "Calculé CHF {{calculated}} · total facture CHF {{total}} · différence CHF {{diff}}",
  previewDocument: "Aperçu du document",
  previewNotAvailable: "Aucun aperçu n'est disponible pour ce document.",
  openedAt: "Dernière ouverture {{time}}",
  recentlyModified: "Récemment modifiés",
  recentlyOpened: "Récemment ouverts",
  recentlyExtracted: "Récemment extraits",
  noRecentDocuments: "Aucun document récent",
  chooseAvatar: "Choisir un avatar animal",
  chooseAvatarHint: "Choisissez un animal. Chaque animal ne peut être utilisé que par un seul opérateur.",
  avatarLoadError: "Impossible de charger les avatars",
  avatarSaveSuccess: "Avatar animal enregistré",
  avatarSaveError: "Impossible d'enregistrer l'avatar",
  avatarTaken: "Cet animal est déjà pris",
  avatarTakenBy: "Pris par {{name}}",
  animalAvatar_dog: "Chien",
  animalAvatar_cat: "Chat",
  animalAvatar_fox: "Renard",
  animalAvatar_owl: "Hibou",
  animalAvatar_bear: "Ours",
  animalAvatar_rabbit: "Lapin",
  animalAvatar_panda: "Panda",
  animalAvatar_lion: "Lion",
  animalAvatar_tiger: "Tigre",
  animalAvatar_wolf: "Loup",
  animalAvatar_deer: "Cerf",
  animalAvatar_hedgehog: "Hérisson",
  animalAvatar_koala: "Koala",
  animalAvatar_penguin: "Pingouin",
  animalAvatar_otter: "Loutre",
  animalAvatar_squirrel: "Écureuil",
  animalAvatar_eagle: "Aigle",
  animalAvatar_dolphin: "Dauphin",
  animalAvatar_horse: "Cheval",
  animalAvatar_frog: "Grenouille",
  reSubmitted: "Soumis à nouveau",
  uploadInvoice: "Téléverser une facture",
  invoiceFile: "Fichier de facture",
  selectInvoiceFile: "Cliquer ou déposer une facture ici",
  supportedInvoiceFiles: "JPG, JPEG, PNG, PDF ou HEIC · max. 14 Mio",
  inboxType: "Type de boîte de réception",
  description: "Description",
  invoiceFileRequired: "Sélectionnez un fichier de facture",
  invoiceFileTypeError: "Utilisez un fichier JPG, JPEG, PNG, PDF ou HEIC",
  invoiceFileSizeError: "Le fichier ne doit pas dépasser 14 Mio",
  invoiceUploadSuccess: "Facture téléversée",
  invoiceUploadError: "Impossible de téléverser la facture",
};

const authManagement = {
  inviteOnlySignup: "Les comptes sont disponibles uniquement sur invitation.",
  invalidInvitation: "Cette invitation est invalide, expirée ou déjà utilisée.",
  acceptInvitation: "Accepter l’invitation",
  name: "Nom",
  confirmPassword: "Confirmer le mot de passe",
  passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
  invitationAccepted: "Invitation acceptée. Connectez-vous pour configurer la MFA.",
  backToLogin: "Retour à la connexion",
  forgotPasswordInstructions: "Saisissez votre e-mail pour recevoir un code.",
  passwordResetEmailSent: "Si le compte existe, un code a été envoyé.",
  sendCode: "Envoyer le code",
  verifyCode: "Vérifier le code",
  invalidOrExpiredCode: "Le code est invalide ou expiré.",
  resendUnavailable: "Un nouveau code ne peut pas encore être envoyé.",
  resetPassword: "Réinitialiser le mot de passe",
  invalidResetLink: "La réinitialisation est invalide ou expirée.",
  passwordPolicy: "12 caractères minimum avec majuscule, minuscule, chiffre et symbole.",
  passwordResetComplete: "Mot de passe réinitialisé.",
  mfaRecovery: "Récupération MFA",
  recoveryCodeSent: "Un code de récupération a été envoyé à {{email}}.",
  recoveryMustStartAtLogin: "Démarrez la récupération depuis l’écran MFA.",
  waitingForAdminApproval: "E-mail vérifié. En attente de l’approbation d’un administrateur.",
  refreshStatus: "Actualiser le statut",
  recoveryRejected: "La demande de récupération a été rejetée.",
  setupNewAuthenticator: "Configurer un nouvel authentificateur",
  usersAndInvitations: "Utilisateurs et invitations",
  inviteUser: "Inviter un utilisateur",
  inviteLanguage: "Langue de l'invitation",
  inviteLanguageHint: "Langue utilisée pour l'e-mail d'invitation.",
  langGerman: "Allemand",
  langEnglish: "Anglais",
  langFrench: "Français",
  langItalian: "Italien",
  used: "Licences utilisées",
  licensed: "Licences disponibles au contrat",
  available: "Licences restantes",
  users: "Utilisateurs",
  invitations: "Invitations",
  role: "Rôle",
  status: "Statut",
  actions: "Actions",
  promote: "Promouvoir",
  demote: "Rétrograder",
  activate: "Activer",
  deactivate: "Désactiver",
  deliveryStatus: "Envoi",
  expiresAt: "Expiration",
  requestedAt: "Demandé",
  resend: "Renvoyer",
  revoke: "Révoquer",
  resendInvitation: "Renvoyer l’invitation",
  revokeInvitation: "Révoquer l’invitation",
  approve: "Approuver",
  reject: "Rejeter",
  approveRecovery: "Approuver la récupération MFA",
  rejectRecovery: "Rejeter la récupération MFA",
  confirmAdminAction: "Confirmez cette action avec votre mot de passe",
  confirmWithPassword: "Votre mot de passe administrateur",
};

export const frJSON = {
  ...commonEvents,
  ...loginComponent,
  ...dashboardComponent,
  ...errorNotification,
  ...commonTranslation,
  ...documentStatus,
  ...confirmationMessage,
  ...successNotification,
  ...batch1Ux,
  ...authManagement
};
